import { combineReducers } from 'redux';
import cart from './cart.reducer';
import dispatchTypes from './dispatchTypes.reducer';
import productCategories from './productCategories.reducer';

export default combineReducers({
  cart,
  dispatchTypes,
  productCategories,
});